











import Vue, { PropType } from "vue";
import { Sort } from "@/types";

export default Vue.extend({
  name: "TableSortHeader",
  props: {
    sort: {
      type: Object as PropType<Sort>,
      default: () => ({ key: "", direction: "" }),
    },
    name: {
      type: String,
      default: "",
    },
  },
  computed: {
    isActive(): boolean {
      return this.name === this.sort.key;
    },
    getColor(): string {
      return this.isActive ? "#000" : "";
    },
    getIcon(): string {
      if (this.isActive) {
        return this.sort.direction === "desc"
          ? "mdi-arrow-down-thin"
          : "mdi-arrow-up-thin";
      }
      return "mdi-arrow-up-down";
    },
  },
  methods: {
    setSort() {
      let newSort = { key: this.name, direction: "asc" };

      if (this.isActive) {
        newSort = {
          ...newSort,
          direction: this.sort.direction === "asc" ? "desc" : "asc",
        };
      }

      this.$emit("sort:set", newSort);
    },
  },
});
